import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, noop, map, capitalize, isEqual } from 'lodash';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import ReactToPrint from "react-to-print";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import {
  commaFormatted,
  normalizeAmount,
} from '../../../../utils/transformer.util';
import {
  Select,
  SearchSelect,
  Button,
} from '../../../../components/base';


const MySwal = withReactContent(Swal);

const initialContent = {
  loading: true,
  list: [],
  currentPage: 1,
  total: 1,
  totalPage: 1,
  error: false,
};

export default class SiswaBatalMasuk extends Component {
  constructor(props) {
    super(props);
    this._onChangeFilter = this._onChangeFilter.bind(this);
    this._onSearchContent = this._onSearchContent.bind(this);
    this.onReset = this.onReset.bind(this);
    this._getUsernameOptions = this._getUsernameOptions.bind(this);
    this._getUserGroups = this._getUserGroups.bind(this);
    this._getSchoolUnitsOptions = this._getSchoolUnitsOptions.bind(this);
    this.getYearsOfEducationsOptions = this.getYearsOfEducationsOptions.bind(this);

    const { user } = this.props;
    const { school_unit } = user;
    this.state = {
      page: 1,
      filters: {},
      form: {
        value: {
          listuser: [],
        },
        error: {},
      },
      param: {},
    };
  }

    componentDidMount() {
      const { user } = this.props;
      const { organizations_id, user_group } = user;
      const { content, form, filters } = this.state;
      let savedForm = JSON.parse(window.localStorage.getItem('manageForm')) || '';
      let savedFilters = JSON.parse(window.localStorage.getItem('manageFilters')) || filters;
      if (savedForm != '' && user.id != savedForm.value.user_id) {
        savedForm = '';
        savedFilters = filters;
      }
      this._initializeData(savedFilters);
      if (savedForm != '') {
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              levels_id: savedForm.value.levels_id,
              units_id: savedFilters.units_id ? savedFilters.units_id : '',
            },
          },
          filters: {
            ...prevState.filters,
            units_id: savedFilters.units_id ? savedFilters.units_id : '',
            // entrance_year : savedFilters.entrance_year,
          },
        }));
  
        // this._getParamOptionsAcademics("classrooms", {
        //   levels_id: savedForm.value.levels_id,
        //   classes_id: savedForm.value.classes_id,
        //   units_id: savedForm.value.units_id.value,
        //   organizations_id,
        // });
  
        if (user_group.name === 'pusat') {
          this.getYearsOfEducationsOptions({
            units_id: savedFilters.units_id ? savedFilters.units_id.value : '',
          });
        }
      }
    }
  
    componentDidUpdate(prevProps) {
      const { user } = this.props;
      const { workingUnit } = user;
      const { user: prevUser } = prevProps;
      const { workingUnit: prevWorkingUnit } = prevUser;
  
      if (!isEqual(workingUnit, prevWorkingUnit)) {
        this._onSearchContent({ page: 1 });
      }
    }
  
    async _initializeData(savedFilters = {}) {
      const { user } = this.props;
      const { content } = this.state;
      const { school_unit, user_group } = user;
  
      if (user_group.name !== 'pusat') {
        await this.getYearsOfEducationsOptions({ units_id: school_unit.id });
        this._onSearchContent();
      } else {
        this.setState(prevState => ({
          filters: {
            ...prevState.filters,
            // entrance_year: savedFilters.entrance_year,
          },
        }),
        () => {
          // commonActions.setLoading({ show: true });
          this._onSearchContent();
        });
      }
    }

  async _getSchoolUnitsOptions(filters = {}) {
    const { getSchoolUnitsOptions } = this.props;
    const { form } = this.state;
    const { units_id } = form.value;
    const res = await getSchoolUnitsOptions(filters);
    const selectedUnits = res.find(item => item.value == units_id);

    // console.log(units_id)
    this.setState(prevState => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          levels_units: selectedUnits ? selectedUnits.attributes.levels_id : '',
        },
      },
      param: {
        ...prevState.param,
        units: res,
      },
    }));
  }


    async getYearsOfEducationsOptions(filters = {}) {
      const { getYearsOfEducationsOptions, user } = this.props;
      const { organizations_id, school_unit, user_group } = user;
      const { form } = this.state;
      const { units_id } = form.value;
      const res = await getYearsOfEducationsOptions(filters);
  
      map(res, (data, idx) => {
        const date = new Date();
        const start_date = new Date(data.attributes.start_date);
        if (date > start_date) {
          // tahun ajaran selanjutnya
          if (res[idx + 1]) {
            this.setState(prevState => ({
              ...prevState,
              filters: {
                ...prevState.filters,
                entrance_year: res[idx + 1].value,
              },
            }));
          }
        }
      });
  
      this.setState(prevState => ({
        ...prevState,
        param: {
          ...prevState.param,
          periods: res,
        },
      }));
    }
  

  _onChangeFilter(e) {
    const { target } = e;
    const { value, name } = target;
    if (name === 'user_groups_id') {
      this.setState(prevState => ({
        filters: {
          ...prevState.filters,
          username: '',
        },
      }));
    }
    this.setState(prevState => ({
      ...prevState,
      filters: {
        ...prevState.filters,
        [name]: value,
      },
    }),
    () => {
      if (name === 'user_groups_id') {
        this._getUsernameOptions();
      }
      if (name === 'units_id') {
        const param = this.state.param.units;
        const levels_units = param.find(i => i.value == value.value) ? param.find(i => i.value == value.value).attributes.levels_id : '';
        const units_id = param.find(i => i.value == value.value) ? param.find(i => i.value == value.value).value : '';

        console.log(levels_units);
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              units_id: value,
            },
            error: {},
          },
          filters: {
            ...prevState.filters,
            username: '',
          },
        }));
        this._getUsernameOptions({ units_id: value });
      }
      this._onSearchContent();
    });
  }

  async _onSearchContent(params = {}) {
    const { param, savedUnits } = this.state;
    const savedFilters = JSON.parse(window.localStorage.getItem('param')) || '';
    const prm_usergroups = savedFilters.userGroups;
    const userStudents = prm_usergroups ? prm_usergroups.find(e => e.label == 'student') : '';


     const {
          handleListResetPassword,
          handleListPPDBF07Cancel,
          handleListPPDBCancel,
          handleListPPDBGeneralCancel,
          user,
        } = this.props;
        const { form, filters } = this.state;
        const { value } = form;
        const { units_id , entrance_year} = filters;
        const { school_unit, organizations_id, user_group } = user;
        const units = user_group.name == 'pusat' ? units_id.value : school_unit.id;
        console.log(entrance_year);

          let year = '';
        if (entrance_year) {
          year = entrance_year.toString().substring(2);
        }
        const subdomain_pst = units_id ? units_id.attributes.subdomain : '';
        const ppdb_online_pst = units_id
          ? units_id.attributes.ppdb_online
          : '';
        const ppdb_name_pst = units_id ? units_id.attributes.ppdb_name : '';
        const unit_code_pst = units_id ? units_id.attributes.unit_code : '';
        const units_id_pst = units_id ? units_id.value : '';

        const ppdb_online = user_group.name == 'pusat'
          ? ppdb_online_pst
          : school_unit.ppdb_online;
        const subdomain = user_group.name == 'pusat' ? subdomain_pst : school_unit.subdomain;
        const unit_code = user_group.name == 'pusat' ? unit_code_pst : school_unit.unit_code;

    this.setState(async () => {
      try {
       
        let result = {};
        if (
          school_unit.ppdb_online == 1
            && school_unit.unit_code == 'F07'
            && school_unit.subdomain == null
        ) {
          result = await handleListPPDBF07Cancel({
            ...params,
            year,
            organizations_id,
            units_id:
                user_group.name == 'pusat' ? units_id_pst : school_unit.id,
          });
        } else if (
          school_unit.ppdb_online == 1
            && school_unit.unit_code !== 'F07'
            && school_unit.subdomain == null
            && organizations_id == 3
        ) {
          result = await handleListPPDBCancel({
            ...params,
            // year: year,
            organizations_id,
            units_id:
                user_group.name == 'pusat' ? units_id_pst : school_unit.id,
            filters: { year },
          });
        } else if (school_unit.ppdb_online == 1 && subdomain !== null) {
          result = await handleListPPDBGeneralCancel({
            ...params,
            subdomain,
            organizations_id,
          });
        }


        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              listuser: result,
            },
          },
        }));
      } catch (err) {
        // if (this.isMount) {
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              listuser: [],
            },
          },
        }));
      }
      // }
    });
  }

  async onReset(data) {
    const { handleSetNominal, history } = this.props;
    // MySwal.fire({
    //   title: <p>Rincian Pembayaran</p>,
    //   // showCancelButton: false,
    //   // showConfirmButton: false,
    //   title: "Reset Kata Sandi",
    //   text: "Username : " + data.username + "<br> Nama",
    //   icon: 'warning',
    //   showCancelButton: true,
    //   showConfirmButton: true,
    // });
    const res = await handleSetNominal(data);
    if(res){
    history.push('/dashboard/tagihan-siswa/siswa-batal-masuk');
   
    history.go(0);
    }


  }

  async _getUsernameOptions() {
    const { getUsernameOptions, user } = this.props;
    const { school_unit, user_group } = user;
    const { filters, param } = this.state;
    const { units_id } = filters;
    const savedFilters = JSON.parse(window.localStorage.getItem('param')) || '';
    const prm_usergroups = savedFilters.userGroups;
    const userStudents = prm_usergroups ? prm_usergroups.find(e => e.label == 'student') : '';
    const units_value = units_id ? units_id.value : '';
    const units = user_group.name == 'pusat' ? units_value : school_unit.id;
    console.log(filters);
    const res = await getUsernameOptions({
      units_id: units,
      filters: { user_groups_id: userStudents.value },
    });
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        user: res,
      },
    }));
  }

  async _getUserGroups() {
    const { getUserGroups, user } = this.props;
    const { school_unit, organizations_id } = user;
    const { filters } = this.state;

    filters.organizations_id = organizations_id;

    const res = await getUserGroups(filters);
    console.log(res);
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        userGroups: res,
      },
    }));
    window.localStorage.setItem('param', JSON.stringify(this.state.param));
  }

  _renderButtons(data) {
    const { user } = this.props;

    return (
      <td>
        <div className="table__actions">
          <Button onClick={() => this.onReset(data)} title="Batal" />
        </div>
      </td>
    );
  }

  render() {
    const {
      form,
      filters,
      param,
    } = this.state;
    const { listuser } = form.value;
    const { user } = this.props;
    const { user_group } = user;
    const prm_usergroups = param.userGroups;
    const prm_user = [
      { value: 1, label: 'User Siswa' },
      { value: 2, label: 'User Guru' },
    ];

    const userStudents = prm_usergroups ? prm_usergroups.find(e => e.label == 'student') : '';
    // window.localStorage.setItem('param', JSON.stringify(this.state.param));

    // console.log(JSON.parse(window.localStorage.getItem('param')))

    // this.setState((prevState) => ({
    //   ...prevState,
    //   form: {
    //     ...prevState.form,
    //     value: {
    //       ...prevState.form.value,
    //       userStudents: userStudents,
    //     }
    //   }
    // }))
    return (
      <div className="manage-registration">
        <h1>Siswa Batal Masuk</h1>
        <hr />
        <div className="absensi-rekap__custom-form">
          <div className="absensi-rekap__custom-form-row">
              <Select
                name="entrance_year"
                label="Tahun Ajaran"
                placeholder="Pilihan"
                onChange={this._onChangeFilter}
                data={param.periods}
                value={filters.entrance_year}
                disabled
              />
          </div>
        </div>
        <div className="manage-registration">
          <div className="fund-request__content">
            <table className="table">
              <thead>
                <tr>
                  <th>No</th>
                  <th>No VA</th>
                  <th>Nama</th>
                  <th>Opsi</th>
                </tr>
              </thead>
              <tbody>
                {map(listuser, (list, idx) => (
                  <tr key={`budget_row_${idx}`}>
                    <td style={{ textAlign: 'center' }} key={`table_$${idx}`}>
                      {idx + 1}
                    </td>
                    <td key={`table_${idx}`} style={{ textAlign: 'center' }}>
                      {list.no_va}
                    </td>
                    <td key={`table_${idx}`} style={{ textTransform: 'capitalize' }}>
                      {capitalize(list.fullname)}
                    </td>
                    {this._renderButtons(list)}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}


SiswaBatalMasuk.propTypes = {
  handleGetStudent: PropTypes.func,
  handleDeleteStudent: PropTypes.func,
  history: PropTypes.object.isRequired,
};
SiswaBatalMasuk.defaultProps = {
  handleGetStudent: noop,
  handleDeleteStudent: noop,
};
